<div class="main-body ubs">
    <app-journey-stage *ngIf="!isError" [journeyStageId]="journeyStage"></app-journey-stage>
    <div *ngIf="!isError" class="guidelines">
        <div class="guidelines-titles">
            <img class="audio-icon" src="assets/icons/btn-sound.png" aria-hidden="false" aria-label="sound" (click)="playAudio()"/>
            <span class="title" i18n>AGORA VOCÊ DEVERÁ SE PESAR</span>
        </div>
        <div class="guidelines-content">
            <div class="row">
                <div class="col-8">
                    <div class="content-block">
                        <div class="red-dot">1</div>
                        <div class="guidelines-text">
                            <span i18n>
                                Vá até a balança e <b>suba na plataforma</b>. Seu peso 
                                aparecerá no visor.
                            </span>
                        </div>
                    </div>
                    <div class="content-block">
                        <div class="red-dot">2</div>
                        <div class="guidelines-text">
                            <span i18n>
                                Pressione o botão "IMC", na balança, para visualizar a sua 
                                altura e IMC na tela.
                            </span>
                        </div>
                    </div>
                    <div class="content-block">
                        <div class="red-dot">3</div>
                        <div class="guidelines-text">
                            <span i18n>
                                Após concluir as aferições, <b>pressione o botão "Imprimir"</b>,
                                na balança.
                            </span>
                        </div>
                    </div>
                </div>
                <div class="guidelines-scale-img">
                    <img src="assets/images/scale-measure.png" />
                </div>                      
            </div>
            <div class="button-container">
                <button mat-flat-button class="block btn-back" (click)="goBack()">
                    <div>
                        <mat-icon class="icon-back material-symbols-rounded">arrow_back</mat-icon>
                    </div>
                    <span i18n>VOLTAR</span>
                </button>
            </div>
        </div>
    </div>
    <app-error-scale-ubs-health-promotion *ngIf="isError" (endFlowMeasurer)="endFlowMeasurer()"
        (retryMeasurer)="retryMeasurer()">
    </app-error-scale-ubs-health-promotion>
</div>